<template>
  <header class="site-header" :class="{ open: isOpen }">
    <div class="logo-container">
      <!-- <img src="@/assets/images/logo-stt.png" alt="Logo" class="logo-img" /> -->
      <img src="logo-stt.png" alt="Logo" class="logo-img" />

      <div class="logo-text">ＳＴＴ株式会社</div>
    </div>
    <nav>
      <!-- <a href="#home" @click="toggleMenu">ホーム</a> -->
      <!-- <router-link to="/">ホーム</router-link> -->
      <router-link :to="{ path: '/', hash: '#home' }" @click="toggleMenu">ホーム</router-link>

      <router-link :to="{ path: '/', hash: '#company-info' }" @click="toggleMenu">会社情報</router-link>
      <!-- <a href="#company-info" @click="toggleMenu">会社情報</a> -->
      <!-- <a href="#about-us" @click="toggleMenu">事業概要</a> -->
      <router-link :to="{ path: '/', hash: '#about-us' }" @click="toggleMenu">事業概要</router-link>
      <router-link :to="{ path: '/', hash: '#news' }" @click="toggleMenu">最新ニュース</router-link>

      <router-link :to="{ path: '/recruit'}" @click="toggleMenu">採用情報</router-link>
      <router-link :to="{ path: '/', hash: '#contact' }" @click="toggleMenu">お問い合わせ</router-link>

      <!-- <a href="#news" @click="toggleMenu">最新ニュース</a> -->
      <!-- <router-link to="/recruit" @click="toggleMenu">採用情報</router-link> -->
    </nav>
    <div class="burger" @click="toggleMenu">
      <div class="burger-line1"></div>
      <div class="burger-line2"></div>
      <div class="burger-line3"></div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',

  data() {
    return {
      isOpen: false,
      scrollThreshold: 80,
    }
  },
  watch: {
  $route() {
    this.setScrollThreshold()
    // const header = document.querySelector('.site-header')
    // header.classList.add('scrolled')
    // this.handleScroll()
    const header = document.querySelector('.site-header')
      if (this.$route.path === '/' && this.$route.hash === '#home') {
        window.scrollTo(0, 10);
        header.classList.remove('scrolled')
      } else if (this.$route.path === '/recruit' ) {
        header.classList.add('scrolled')
      }
  }
},
  mounted() {
    this.$nextTick(function () {
    // 计算轮播高度作为滚动阈值
      this.setScrollThreshold()
      window.scrollTo(0, 1);
    })

    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      this.setScrollThreshold()
      window.scrollTo(0, 1);

      const header = document.querySelector('.site-header')
      if (this.$route.path === '/' && this.$route.hash === '#home') {
        window.scrollTo(0, 10);
        header.classList.remove('scrolled')
      } else if (this.$route.path === '/recruit' ) {
        header.classList.add('scrolled')
      }
    },


    setScrollThreshold() {
      const header = document.querySelector('.site-header')
      let checkCount = 0

      const interval = setInterval(() => {
        const carousel = document.querySelector('.carousel')

        if (carousel) {
          this.scrollThreshold = carousel.offsetHeight || 80
          clearInterval(interval)
          // 后续交给滚动监听处理
        } else {
          this.scrollThreshold = 0
          checkCount++
          header.classList.add('scrolled')
          if (checkCount > 100) {
            // 超过尝试次数后判定页面没有 carousel，直接加样式
            // header.classList.add('scrolled')
            clearInterval(interval)
            window.removeEventListener('scroll', this.handleScroll) // 无需监听滚动
          }
        }
      }, 100) // 每 100ms 检查一次，最多 10 次（1秒）
    },



    handleScroll() {
      const carousel = document.querySelector('.carousel')
      const header = document.querySelector('.site-header')
      if (carousel) {
        this.scrollThreshold = 80

        if (window.scrollY >= this.scrollThreshold) {
          header.classList.add('scrolled')
          // alert(window.scrollY)
        } else {
         
          header.classList.remove('scrolled')
        }
      }
      else {
        this.scrollThreshold = 0
        // 没有 carousel，直接添加背景色
        header.classList.add('scrolled')
      }

    }
  }

}
</script>

<style scoped>
/* 你原来的 header 样式可以放进这里 */
/* .site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; 
  background-color: #fff; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
} */
/* 透明背景 */
/* 文字颜色调亮 */
/* 可自定义 */
/* .site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: transparent; 
  color: #fff;
  padding: 20px 40px;
} */
/* 初始透明 */
/* .site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0);
  transition: background-color 0.3s ease;
} */

/* 滚动后半透明白 */
/* .site-header.scrolled {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
} */


.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  color: #000;
  background-color: #a8cee9;

  /* background-color: transparent; */
  /* transition: background-color 0.3s ease; */
  
}

.site-header.scrolled {
  /* background-color: rgba(255, 255, 255, 0.92); */
  background-color: rgba(168, 206, 233, 0.92);
  /* 加透明度 */
  color: #000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tech-recruit {
  background-color: #a8cee9;
  color: #1a1a1a;
}
</style>
